import _Object$assign from 'babel-runtime/core-js/object/assign';
import _isPlainObject from 'lodash.isplainobject';

export default function () {
  var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var propertyUnit = void 0;
  if (_isPlainObject(field.unit)) {
    if (field.displayUnit) {
      propertyUnit = _Object$assign({}, field.unit, {
        name: field.displayUnit
      });
    } else {
      propertyUnit = _Object$assign({}, field.unit);
    }
  }

  return propertyUnit;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/convertRestriction/getUnit.js
// module id = 79
// module chunks = 0